import { useForm } from '@refinedev/antd';
import { BaseKey } from '@refinedev/core';
import { Checkbox, Form, Modal, ModalProps } from 'antd';

export const FootballFestCategoryEditModal = ({
  recordId,
  onClose,
  ...props
}: ModalProps & {
  recordId: BaseKey;
  onClose: () => void;
}) => {
  const { formProps, form } = useForm({
    action: 'edit',
    resource: 'football-fest/category',
    id: recordId,
    onMutationSuccess: () => {
      onClose();
    },
    successNotification: (data) => {
      return {
        message: `Updated league ${data?.data.id}`,
        type: 'success',
      };
    },
  });

  return (
    <Modal
      {...props}
      onOk={() => form.submit()}
      okText="Save"
      onCancel={onClose}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Is active"
          name={['isActive']}
          valuePropName="checked"
        >
          <Checkbox />
        </Form.Item>
      </Form>
    </Modal>
  );
};
